// frontend/src/DesignTab/MmiLegend.tsx
import React from "react";
import { Box, Group, Text, ScrollArea, Tooltip, Stack, Divider } from "@mantine/core";
import { MiniPie } from "./MiniPie";
import { useAppSelector } from "../../app/hooks";
import { MMI_COLORS } from "../../RoomColoring";
import { selectMmiDistributionForArkItems } from "../mmiSelectors";

export const MmiLegend: React.FC = () => {
  const dist = useAppSelector(selectMmiDistributionForArkItems);

  if (dist.total <= 0 || dist.rows.length === 0) {
    return null;
  }

  const slices = dist.rows.map((r) => ({
    value: r.count,
    color: MMI_COLORS[r.mmi] ?? "#ccc",
  }));

  const tooltip = (
    <Stack gap={6} p={2}>
      <Text size="xs" fw={600}>
        MMI-fordeling
      </Text>

      <Text size="xs" c="dimmed">
        Total: {dist.total}
      </Text>

      <Divider />

      {dist.rows.map((r) => (
        <Group key={r.mmi} justify="space-between" gap="lg" wrap="nowrap">
          <Group gap={8} wrap="nowrap">
            <Box
              style={{
                width: 10,
                height: 10,
                borderRadius: 3,
                background: MMI_COLORS[r.mmi] ?? "#ccc",
                border: "1px solid rgba(0,0,0,0.18)",
                flex: "0 0 auto",
              }}
            />
            <Text size="xs" c="dimmed" style={{ whiteSpace: "nowrap" }}>
              MMI {r.mmi}
            </Text>
          </Group>

          <Text size="xs" fw={600} style={{ whiteSpace: "nowrap" }}>
            {r.count}{" "}
            <Text component="span" size="xs" c="dimmed" style={{ opacity: 0.8 }}>
              ({r.percent.toFixed(0)}%)
            </Text>
          </Text>
        </Group>
      ))}
    </Stack>
  );

  return (
    <Box
      w="100%"
      px="sm"
      py={6}
      style={{
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        background: "rgba(255,255,255,0.75)",
        backdropFilter: "blur(4px)",
      }}
    >
      <ScrollArea h={28} type="never" scrollbarSize={0} offsetScrollbars={false}>
        <Group gap="md" wrap="nowrap" align="center">
          <Tooltip label={tooltip} withArrow position="bottom" multiline>
            <Group gap={8} wrap="nowrap" style={{ cursor: "default" }}>
              <MiniPie size={18} strokeWidth={6} slices={slices} />
              <Text size="xs" c="dimmed" style={{ whiteSpace: "nowrap" }}>
                MMI-fordeling
                <Text component="span" size="xs" c="dimmed" style={{ opacity: 0.8 }}>
                  {" "}
                  · {dist.rows.length} nivåer
                </Text>
              </Text>
            </Group>
          </Tooltip>

          {/* Valfritt: fortsatt visa pills per MMI i raden (kan tas bort om du vill hålla det supertight) */}
          <Group gap="sm" wrap="nowrap">
            {dist.rows.map((r) => (
              <Group key={r.mmi} gap={6} wrap="nowrap">
                <Box
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: 3,
                    background: MMI_COLORS[r.mmi] ?? "#ccc",
                    border: "1px solid rgba(0,0,0,0.18)",
                    flex: "0 0 auto",
                  }}
                />
                <Text size="xs" c="dimmed" style={{ whiteSpace: "nowrap" }}>
                  {r.mmi}
                </Text>
              </Group>
            ))}
          </Group>
        </Group>
      </ScrollArea>
    </Box>
  );
};
